import React from 'react';
import "./ui.css";
import spin from '../../assets/spin.gif';

const Loading = () => {
  return (
    <div className='loading-comp'>
        <img src={spin} alt="loading" />
    </div>
  )
}

export default Loading